import { render } from "./base-video-player.vue?vue&type=template&id=42fd22d8"
import script from "./base-video-player.vue?vue&type=script&lang=js"
export * from "./base-video-player.vue?vue&type=script&lang=js"
script.render = render

export default script